import React, { useContext } from 'react'
import { Button } from 'react-bootstrap'
import { SettingsContext } from '@/context/settings-context'
import ActiveLight from '@/assets/images/accept-modal/accept-meta-active-light.svg'
import ActiveDark from '@/assets/images/accept-modal/accept-meta-active-dark.svg'
import NoActiveLight from '@/assets/images/accept-modal/accept-meta-noactive-light.svg'
import NoActiveDark from '@/assets/images/accept-modal/accept-meta-noactive-ldark.svg'
import { CubeLoader } from '@/components/ui/cube-loader'

const TermsOfServiceModal = ({ faceBookTOSRetrieval, onAcceptOnFacebook, isAccepted }) => {
    const { theme } = useContext(SettingsContext)
    const isLight = theme === 'light'

    const getIcon = () => {
        if (isAccepted === true) return isLight ? ActiveLight : ActiveDark
        return isLight ? NoActiveLight : NoActiveDark
    }

    return (
        <div
            className={`w-100 d-flex flex-column align-items-center px-4 py-5 ${
                isLight ? 'text-dark bg-white' : 'text-white'
            }`}
        >
            <div
                className="mx-auto d-flex align-items-center justify-content-center rounded-circle mb-4"
                style={{ width: '80px', height: '80px' }}
            >
                <img src={getIcon()} alt="tos status icon" width="80" height="80" />
            </div>

            <div className="mb-4 pb-3 text-center" style={{ maxWidth: 365, width: '100%', fontSize: '14px' }}>
                {isAccepted === true ? (
                    <>
                        Meta’s Terms of Service
                        <br />
                        accepted.
                    </>
                ) : isAccepted === null ? (
                    <CubeLoader fullScreen={false} className="mt-2 pt-2" height={60} />
                ) : (
                    'To use Turba Media, we need you to accept Meta’s Terms of Service. Click below to read and accept.'
                )}
            </div>

            {isAccepted === false && (
                <Button
                    className="btn-14px btn-outline-secondary"
                    style={{ minWidth: 170 }}
                    onClick={() =>
                        onAcceptOnFacebook(faceBookTOSRetrieval.ad_account, faceBookTOSRetrieval.publisherName)
                    }
                >
                    Accept on Facebook
                </Button>
            )}
        </div>
    )
}

export default TermsOfServiceModal
